// import smoothscroll from 'smoothscroll-polyfill';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6.js';

import { Gradient } from 'gradientAnimation';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
import 'partials/scroll-interval.js';
import 'partials/target-blank-security.js';

import * as functions from 'partials/functions.js';

import FilterPosts from 'partials/filter-posts.js';
import MobileMenu from 'partials/mobile-menu.js';
import Swiper, { Pagination, Autoplay/*, EffectFade*/ } from 'swiper/core';

import * as cookiesBar from 'partials/cookies-bar.js';

import * as globalVarFunctions from 'partials/global-variables.js';

(function() {

	/*** Variables globales ***************************************************************************/
	globalVarFunctions.setGlobalVariables();

	/*** Animation de dégradé du hero de l'accueil ***********************************************/
	(function() {
		const gradientCanvas = document.querySelectorAll( '.gradient-animation__canvas' );

		gradientCanvas.forEach( function( thisCanva ) {

			if( thisCanva !== undefined ) {
				new Gradient( thisCanva, ['#000105', '#E74237', '#034D77', '#000105'], {
					seed: 26,
					scaleY: 0.5,
					scaleX: 1.4
				});
			}

		});

	}) ();

	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres *************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');

		linksWithHash.forEach( function( thisLink ) {
			if( functions.urlsAreSamePage({ urls: [ thisLink.href, window.location.href ] }) ) {
				thisLink.href = thisLink.hash;
			}
		} );
	}) ();

	/*** Défiler doucement les liens ancres ************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js
	// Ajuster la variable globale window.fixedElHeight

	(function() {
		if( window.smoothScroller ) {
			let smoothScrollLinks = document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.no-smooth-scroll):not([target])');

			smoothScrollLinks.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.addEventListener( 'click', function( event ) {
						if( 1 == event.which ) {
							event.preventDefault();

							window.smoothScroller.scrollTo({
								target: thisEl.hash,
								topCorrection: thisEl.dataset.topCorrection != undefined ? thisEl.dataset.topCorrection : false,
								leftCorrection: thisEl.dataset.leftCorrection != undefined ? thisEl.dataset.leftCorrection : false,
							});
						}
					} );
				}
			});
		}
	}) ();

	/*** Ne rien faire au clic sur un lien vide (#) ****************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) && functions.scriptsOk( linkClicked ) ) {
					event.preventDefault();
				}
			}
		} );
	}) ();

	/*** Remplacer les images par les videos on hover ********************************************/

	(function() {
		document.querySelectorAll('.iframe-box').forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) && thisEl.dataset.iframeUrl !== undefined ) {
				thisEl.addEventListener( 'mouseover', function() {
					let iframe = document.createElement('iframe');

					iframe.width = '100%';
					iframe.height = '100%';
					iframe.src = thisEl.dataset.iframeUrl;

					thisEl.removeAttribute('style');
					thisEl.appendChild( iframe );

					thisEl.removeEventListener('mouseover', function() {});
				}, false );
			}
		} );
	}) ();

	/*** Lazy load des images et backgrounds *****************************************************/
	// Requiert vanilla-lazyload

	(function() {
		let loadedEvent = new Event( 'lazyloaded' );

		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
			// use_native: true,
			callback_loaded: function( element ) {
				element.dispatchEvent( loadedEvent );
			},
		});
	}) ();

	/*** Faire apparaître les dropdown de checkbox sur les filtres *******************************/

	/*(function() {
		document.querySelectorAll('.filter-bar__control').forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) && thisEl.dataset.filterDropdown !== undefined ) {
				thisEl.addEventListener( 'click', function() {
					let thisDropdown = document.getElementById( thisEl.dataset.filterDropdown );

					if( thisEl.classList.contains('-active') === false ) {

						document.querySelectorAll('.filter-bar__control.-active').forEach( function( thisFilter ) {
							thisFilter.classList.remove('-active');
							document.getElementById( thisFilter.dataset.filterDropdown ).classList.remove('-active');
						});

						thisDropdown.classList.add('-active');
						thisEl.classList.add('-active');
					} else {
						thisDropdown.classList.remove('-active');
						thisEl.classList.remove('-active');
					}

				} );
			}
		} );
	}) ();*/

	/*** Appliquer les filtres dans les archives lorsque nécessaire ************************************/

	(function() {

		/*document.querySelectorAll('.filter-bar__form').forEach(function( thisForm ) {
			if( functions.scriptsOk( thisForm ) ) {
				new FilterPosts({
					form: thisForm,
					container: document.querySelector( '#app .iss-container' ),
					containerInnerSel: '.card-list',
					itemSel: '.card-list__item',
					resetButton: '.clear-filter',
					useInner: true,
					animate: false,
					debug: false,
				});
			}
		} );*/

		document.querySelectorAll('.filters-form').forEach(function( thisForm ) {
			if( functions.scriptsOk( thisForm ) ) {
				new FilterPosts({
					form: thisForm,
					container: document.querySelector( '#app .iss-container' ),
					containerInnerSel: '.card-list',
					itemSel: '.card-list__item',
					resetButton: '.clear-filter',
					useInner: true,
					animate: false,
					debug: false,
				});
			}
		} );


	}) ();

	/*** Permettre d'afficher masquer les filtres sur mobile *******************************************/

	(function() {

		if( window.vWidth <= 1024 ) {
			document.querySelectorAll('.show-filters-link').forEach(function( thisEl ) {
				thisEl.addEventListener( 'click', function( event ) {
					event.preventDefault();

					thisEl.parentElement.nextElementSibling.classList.add( 'visible' );

					disableBodyScroll( thisEl.parentElement.nextElementSibling );
				});
			});

			document.querySelectorAll('.close-filters').forEach(function( thisEl ) {
				thisEl.addEventListener( 'click', function( event ) {
					event.preventDefault();

					thisEl.closest('.checkboxes-filters').classList.remove( 'visible' );

					enableBodyScroll( thisEl.closest('.checkboxes-filters') );
				});
			});
		}

	}) ();

	/*** Appliquer les tris dans les archives lorsque nécessaire ***************************************/

	(function() {

		document.querySelectorAll('.sort-select').forEach(function( thisSelect ) {
			if( functions.scriptsOk( thisSelect ) ) {

				thisSelect.addEventListener( 'change', function() {

					let url = new URL( window.location.href );

					url.searchParams.set( 'sort', thisSelect.value );

					window.location.href = url;

				} );

			}
		});

	}) ();

	/*** Action sur la barre de filtres mobile *********************************************************/

	(function() {

		let openFilterPanelBtn = document.querySelectorAll( '.filter-bar-panel-open' ),
			closeFilterPanelBtn = document.querySelectorAll( '.filter-bar-panel-close' ),
			filterPanel = document.getElementById( 'filter-bar-panel' );

		openFilterPanelBtn.forEach(function( thisLink ) {

			thisLink.addEventListener( 'click', function( event ) {
				event.preventDefault();

				if( ! filterPanel.classList.contains('-opened') ) {
					filterPanel.classList.add('-opened');
					disableBodyScroll( filterPanel, { reserveScrollBarGap: true } );
				} else {
					filterPanel.classList.remove('-opened');
					enableBodyScroll( filterPanel, { reserveScrollBarGap: true } );
				}

			} );

		} );

		closeFilterPanelBtn.forEach(function( thisLink ) {

			thisLink.addEventListener( 'click', function( event ) {
				event.preventDefault();

				filterPanel.classList.remove('-opened');
				enableBodyScroll( filterPanel, { reserveScrollBarGap: true } );
			} );

		} );

	}) ();

	/*** Faire ouvrir les dropdowns des 2 menus qui en ont *********************************************/
	(function() {
		document.querySelectorAll('.nav-with-dropdown').forEach(function( thisMenu ) {
			if( functions.scriptsOk( thisMenu ) ) {
				let thisMenuItemParent, dropdownContainer, mouseLeaveClass;

				if( thisMenu.classList.contains( '-sticky' ) ) {
					thisMenuItemParent = thisMenu.querySelector('.main-nav-sticky-menu');
					dropdownContainer = thisMenu.querySelector('.dropdown-container');
					mouseLeaveClass = 'main-nav-sticky-menu';
				} else {
					thisMenuItemParent = thisMenu.querySelector('.main-nav-menu');
					dropdownContainer = thisMenuItemParent;
					mouseLeaveClass = 'main-nav-desktop';
				}

				thisMenu.querySelectorAll('.nav__item').forEach(function( thisMenuItem ) {

					if( functions.scriptsOk( thisMenuItem ) ) {

						let dropdownToOpen = false;

						if( thisMenuItem.classList.contains( '-has-dropdown' ) ) {

							thisMenuItem.classList.forEach( name => {
								if( name.indexOf( 'open-' ) === 0 ) {
									dropdownToOpen = name.replace( 'open-', '' );
								}
							} );

							if( dropdownToOpen && thisMenuItemParent !== null ) {

								let dropdownElement = document.getElementById( dropdownToOpen );

								if( dropdownElement !== null ) {
									let dropdownClone = dropdownElement.cloneNode( true );

									thisMenuItem.addEventListener( 'mouseover', function() {

										// On supprime tous ceux qui existe si c'est le cas
										functions.closeAllDropdown( dropdownContainer );

										// On copie le menu
										thisMenuItem.classList.add('-dropdown-open');

										dropdownClone.classList.add('-opened');
										dropdownClone.classList.remove('hidden');
										dropdownClone.removeAttribute('id');

										dropdownContainer.appendChild( dropdownClone );

									} );

									thisMenuItemParent.addEventListener( 'mouseleave', function() {
										if( ! event.target.classList.contains( mouseLeaveClass ) ) {
											functions.closeAllDropdown( dropdownContainer, thisMenuItem );
										}
									} );

								}

							}

						} else {
							thisMenuItem.addEventListener( 'mouseenter', function() {
								functions.closeAllDropdown( dropdownContainer );
							} );
						}

					}

				} );

				dropdownContainer.addEventListener( 'mouseleave', function() {
					functions.closeAllDropdown( dropdownContainer );
				} );

			}
		} );

	}) ();

	/*** Faire ouvrir le menu mobile *******************************************************************/
	(function() {

		let mobileMenu = document.getElementById( 'mobile-menu' );

		if( mobileMenu !== null ) {
			let mobileMenuScrollContainer = mobileMenu.querySelector( '.mobile-main-menu-container' );

			if( mobileMenuScrollContainer !== null ) {
				document.getElementById('open-mobile-menu-btn').addEventListener( 'click', function( event ) {
					event.preventDefault();

					if( ! mobileMenu.classList.contains('-opened') ) {
						mobileMenu.classList.add('-opened');
						disableBodyScroll( mobileMenuScrollContainer, { reserveScrollBarGap: true } );
					}
				} );

				document.getElementById('close-mobile-menu-btn').addEventListener( 'click', function( event ) {
					event.preventDefault();

					if( mobileMenu.classList.contains('-opened') ) {
						mobileMenu.classList.remove('-opened');
						enableBodyScroll( mobileMenuScrollContainer, { reserveScrollBarGap: true } );
					}
				} );
			}
		}

	}) ();

	/*** Menu mobile maison ****************************************************************************/

	(function() {
		new MobileMenu({
			menuSel: '.nav__mobile_container',
			// linkSel: '.menu__link',
			// dropdownParentSel: '.-has-dropdown',
			// scrollableElSel: '.menu__content--section',
			// debug: true,
			dropdownParentLinkActive: false,

			// Si on agrandit la fenêtre dans ce media query, le menu se ferme automatiquement.
			closeMediaQuery: '(min-width: 900px)',
		});
	}) ();

	/*** smoothFadeIn - effet d'apparition lorsque dans le viewport ************************************/
	// Requiert functions.smoothFadeIn
	// Options dans general-styles.scss

	(function() {
		let fadeInItems = document.querySelectorAll('.smooth-fade-in');

		fadeInItems.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {

				functions.smoothFadeIn( thisEl );

				window.addEventListener( 'scrollinterval', function() {
					functions.smoothFadeIn( thisEl );
				} );

			}
		} );
	}) ();

	/*** Sliders Swiper ********************************************************************************/
	// Requiert Swiper
	(function() {
		Swiper.use( [ Pagination, Autoplay ] );

		new Swiper( '.header-slider', {
			speed: 400,
			spaceBetween: 15,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: false,
			// touchEventsTarget: 'header-slider__content',
			preventInteractionOnTransition: true,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: false,

			// wrapperClass: 'header-slider__wrap',
			// slideClass: 'header-slider__content',
			// slideActiveClass: '-active',

			lazy: {
				loadPrevNext: true,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				bulletElement: 'button',
				bulletClass: 'header-slider__dot',
				bulletActiveClass: '-active',
				clickable: true,
				dynamicBullets: true,
				enabled: true,
			},
			breakpoints: {
				/*700: {
					slidesPerView: 2,
				},*/
				1000: {
					slidesPerView: 4,
					pagination: {
						enabled: false,
					},
				},
			},
		});
	}) ();

	/*** Gérer le formulaire d'infolettre **************************************************************/
	/*(function() {
		document.getElementById('newsletter_button').addEventListener( 'click', function( event ) {
			event.preventDefault();

			let f_container = document.getElementById('newsletter_form'),
				f_button = document.getElementById('newsletter_button'),
				f_name = document.getElementById('newsletter_name'),
				f_email = document.getElementById('newsletter_email'),
				f_occupation = document.getElementById('newsletter_occupation'),
				result_container = document.getElementById('newsletter_result'),
				emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
				errorNode = document.createElement("p"),
				error = false, input_error, thisErrorNode;

			f_container.querySelectorAll('.input__error').forEach(function( thisEl ) { thisEl.remove(); });

			f_button.setAttribute( 'disabled', true );

			errorNode.classList.add('input__error', '-newsletter');

			if( f_name.value === '' ) {
				f_name.classList.add('-error');

				thisErrorNode = errorNode.cloneNode();
				thisErrorNode.textContent = atnGlobals.i18n.validation.valueMissing;
				f_name.closest('.input').appendChild( thisErrorNode );

				error = true;
			}

			if( f_email.value === '' || f_email.value.match( emailRegex ) === null ) {
				f_email.classList.add('-error');

				thisErrorNode = errorNode.cloneNode();
				thisErrorNode.textContent = atnGlobals.i18n.validation.typeMismatch.email;
				f_email.closest('.input').appendChild( thisErrorNode );

				error = true;
			}

			if( f_occupation.value === '' ) {
				f_occupation.classList.add('-error');

				thisErrorNode = errorNode.cloneNode();
				thisErrorNode.textContent = atnGlobals.i18n.validation.valueMissing;
				f_occupation.closest('.input').appendChild( thisErrorNode );

				error = true;
			}

			if( ! error ) {

				let formData = new FormData();

				formData.append( 'action', 'mailchimp_subscribe' );
				formData.append( 'name', f_name.value );
				formData.append( 'email', f_email.value );
				formData.append( 'occupation', f_occupation.value );
				formData.append( 'wp_nonce', atnGlobals.nonce );

				// console.log(atnGlobals.ajaxUrl);

				fetch( atnGlobals.ajaxUrl, {
					method: 'POST',
					credentials: 'same-origin',
					// body: JSON.stringify( formData )
					body: formData
				})
				.then(
					( response ) => response.json()
				).then( ( result ) => {
					if( result.success === true ) {
						result_container.innerText = result.data;

						result_container.classList.remove('-error');
						result_container.classList.remove('hidden');
						result_container.classList.add('-success');
					} else {
						result_container.innerText = result.data;

						result_container.classList.remove('-success');
						result_container.classList.remove('hidden');
						result_container.classList.add('-error');

						f_button.removeAttribute( 'disabled' );
					}
				}).catch( ( error ) => {
					result_container.innerText = error.data;

					result_container.classList.remove('-success');
					result_container.classList.remove('hidden');
					result_container.classList.add('-error');

					f_button.removeAttribute( 'disabled' );
				});

			} else {
				f_button.removeAttribute( 'disabled' );
			}
		} );
	}) ();*/

	/*** Copier la citation d'une enquête **************************************************************/
	( function() {
		let bubbleHideTimer = null;

		document.querySelectorAll('.share__citation').forEach( function( thisEl ) {
			thisEl.addEventListener( 'click', function() {
				if( bubbleHideTimer === null ) {
					navigator.clipboard.writeText( thisEl.dataset.citationContent );

					thisEl.querySelector('.share__citation--bubble').classList.add( 'opened' );

					bubbleHideTimer = setTimeout( function( ) {
						thisEl.querySelector('.share__citation--bubble').classList.remove( 'opened' );
						bubbleHideTimer = null;
					}, 3000 );
				}
			} ) ;
		} );
	} ) ();

	/*** Ouvrir le popup d'infolettre ******************************************************************/
	( function() {
		document.querySelectorAll('.cta-newsletter__link').forEach( function( thisEl ) {
			thisEl.addEventListener( 'click', function() {
				thisEl.nextElementSibling.classList.toggle('smooth-hidden');
			} ) ;
		} );

		document.querySelectorAll('.cta-newsletter-popup__close-button').forEach( function( thisEl ) {
			thisEl.addEventListener( 'click', function() {
				thisEl.parentElement.classList.add('smooth-hidden');
			} ) ;
		} );
	} ) ();


	/*** Ouvrir les détails ******************************************************************/
	( function() {
		document.querySelectorAll('.show-hidden-content').forEach( function( thisEl ) {
			thisEl.addEventListener( 'click', function( e ) {
				e.preventDefault();

				if( thisEl.dataset.action === 'show' ) {
					document.getElementById( thisEl.dataset.element ).classList.remove('smooth-hidden');

					thisEl.dataset.action = 'hide';
					thisEl.innerText = thisEl.dataset.closeText;
				} else {
					document.getElementById( thisEl.dataset.element ).classList.add('smooth-hidden');

					thisEl.dataset.action = 'show';
					thisEl.innerText = thisEl.dataset.openText;
				}

			} ) ;
		} );
	} ) ();

	/*** Gestion des préférence de cookies ***************************************/
	(function() {
		window.acceptedCookies = cookiesBar.getCookie('acceptedCookies');

		if( 'function' == typeof cookiesBar.cookieConsent ) {
			cookiesBar.cookieConsent();
		}
	}) ();

}) ();